import introSec from "../../../../assets/web-application-security";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/web-application-security";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const WebApplicationSecurity = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Web Application Security"
      heroSubtitle="Securing the applications that power the digital world."
      heroImage={introSec}
      introParagraphs={[
        "Web Application Security focuses on identifying, preventing, and mitigating vulnerabilities in modern web-based systems. Since most organizations rely heavily on web apps for business and communication, ensuring their security is critical.",
        "At JR Institute of Information Technology (JRIIT) in Tanzania, students gain both theoretical and practical skills to defend applications against common attacks, such as SQL injection, cross-site scripting (XSS), cross-site request forgery (CSRF), and insecure authentication.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students study secure coding principles, application security frameworks like OWASP Top 10, and vulnerability analysis techniques. They learn to evaluate software design, authentication methods, and data validation strategies.",
          "Hands-on labs include exploiting and patching web application vulnerabilities in controlled environments, testing API endpoints, and configuring web application firewalls (WAFs). Through these exercises, students build the skills to protect real-world applications.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners participate in bug bounty challenges, industry-driven projects, and internships where they test and secure live web applications.",
          "Graduates of this module are prepared for roles such as web security engineers, secure software developers, penetration testers, or application security consultants, contributing directly to safer online services.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "WEB APPLICATION SECURITY + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What sets JRIIT apart is our focus on combining development and security skills. Students not only learn how attackers exploit web apps but also how to design and code securely from the ground up.",
          "With our hands-on, real-world approach, graduates emerge with the confidence to build, test, and secure web applications that meet modern cybersecurity standards.",
        ],
      }}
    />
  );
};

export default WebApplicationSecurity;
